// extracted by mini-css-extract-plugin
export default {"title":"ABXR18lS7PwWy9ujmjel"};